// extracted by mini-css-extract-plugin
export default {"notification":"src-modules-dashboard-components-NotificationBanner-style__notification_sRRB8","button":"src-modules-dashboard-components-NotificationBanner-style__button_8v7n8"};